import { Injectable } from '@angular/core'
import { MatDialogConfig } from '@angular/material/dialog'
import { BdcCreatePropertyContactDialogComponent } from './bdc-create-property-contact-dialog.component'
import { BdcContact } from '@tokeet-frontend/channel-content'
import { DialogService, isSomething } from '@tokeet-frontend/tv3-platform'
import { filter, take } from 'rxjs/operators'

@Injectable()
export class BdcCreatePropertyContactDialogService {
  constructor(private dialog: DialogService) {}

  open(data: {
    contact: BdcContact | null
    propertyId: number
    contactIndex?: number
    otherContacts: BdcContact[]
    isGeneralMissing?: boolean
  }) {
    const defaultConfig: MatDialogConfig = {
      width: '700px',
      height: 'auto',
      data,
    }

    return this.dialog
      .openVariableDialog<BdcCreatePropertyContactDialogComponent, BdcContact[]>(
        BdcCreatePropertyContactDialogComponent,
        defaultConfig
      )
      .afterClosed()
      .pipe(filter(isSomething), take(1))
  }
}
